export const useSxStyles = () => {
  return {
    dialogTableHeader: {
      fontSize: '14px',
      textAlign: 'left',
    },
    dialogTableTdBold: {
      fontSize: '14px',
      fontWeight: 'bold',
      width: '180px',
      minWidth: '100px',
    },
    dialogTableTd: {
      fontSize: '14px',
      width: '180px',
      minWidth: '100px',
    },
    dialog: {
      height: 'auto',
      width: '1286px',
    },
    table: {
      borderCollapse: 'collapse',
      cellSpacing: '0px 4px',
      textAlign: 'left',
      '& thead': {
        backgroundColor: '#f6f6f6',
        '& th': {
          padding: '6px 8px 4px 8px',
          textAlign: 'left',
          fontSize: '13px',
          fontWeight: 'bold',
          border: 'none',
          color: '#336699',
        },
      },
      '& tbody': {
        '& td': {
          padding: '6px 8px',
          border: 'none',
          borderBottom: 'solid 1px #ddd !important',
          cursor: 'pointer',
        },
      },
    },
  };
};
